"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylePreview = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const StyleHelper_1 = require("../Utilities/Helpers/StyleHelper");
const join_1 = tslib_1.__importDefault(require("./utils/join"));
const StylePreview = (props) => {
    var _a, _b, _c;
    return (React.createElement(rebass_1.Box, Object.assign({}, props, { className: (0, join_1.default)('ab-StylePreview', props.className), padding: (_a = props.padding) !== null && _a !== void 0 ? _a : 2, mt: (_b = props.mt) !== null && _b !== void 0 ? _b : 2, style: Object.assign(Object.assign({}, (0, StyleHelper_1.toStyle)(props.styleObject)), props.style) }), (_c = props.children) !== null && _c !== void 0 ? _c : 'Preview result'));
};
exports.StylePreview = StylePreview;
